import type { StatusTone } from '../../design-system';

export function absenceEvidenceStatus({ policySnapshot, requestStatus, endDate, today, documents }: {
  policySnapshot?: string;
  requestStatus?: string;
  endDate?: string;
  today: string;
  documents: readonly { scanStatus: string }[];
}): { label: string; tone: StatusTone } | undefined {
  if (policySnapshot !== 'BEFORE_REQUEST' && policySnapshot !== 'AFTER_USE') return undefined;
  if (documents.length) {
    return documents.every((document) => document.scanStatus === 'CLEAN')
      ? { label: '증빙 제출됨', tone: 'success' }
      : { label: '증빙 확인 필요', tone: 'warning' };
  }
  // 원 승인 문서의 완료 상태는 원 휴가의 취소 여부를 나타내지 않는다.
  if (!requestStatus) return undefined;
  if (['CANCELLED', 'REJECTED', 'DENIED', 'WITHDRAWN'].includes(requestStatus ?? '')) return undefined;
  if (policySnapshot === 'BEFORE_REQUEST') return { label: '신청 전 증빙 필요', tone: 'warning' };
  if (requestStatus === 'APPROVED' && endDate && endDate < today) {
    return { label: '증빙 제출 필요', tone: 'warning' };
  }
  return { label: '사용 후 증빙 제출', tone: 'neutral' };
}
